/**
 * Reads a whole file into memory. Kept in its own module so tests can replace
 * it: jsdom does not implement `Blob.prototype.arrayBuffer` in every version.
 */
export async function readFileBytes(file: Blob): Promise<Uint8Array> {
  return new Uint8Array(await file.arrayBuffer());
}
